module.exports = __webpack_public_path__ + "img/P150T_weapon_35.64c16d03.png";